module.exports = __webpack_public_path__ + "2fe3440bad8d45c81af0e3617da4e1bb.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/burger.svg
 ** module id = 431
 ** module chunks = 0
 **/